import axios from 'axios';
export const BasePath   =   "https://adm.pavithram.org/api/v1/";
export const AdminPath  =   "https://adm.pavithram.org";  
const ApiToken          =   "1|rwaoFXx3zmzTKfdEedCjCdlw8u6Rbpldn5AIzlwG"; //live
//const ApiToken          =   "1|IoeXhFjBjHm1YPLNamaV02VN13O6PGNSk76fze8M";
export const instance   =   axios.create({ 
                                headers: {
                                    'Authorization': 'Bearer '+ApiToken
                                }
                            });   